import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import TopBar from '../Layouts/TopBar';
import './TenantProfile.css';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import Swal from 'sweetalert2';

const TenantProfile = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [referralLink, setReferralLink] = useState('');
  const [favoriteProperties, setFavoriteProperties] = useState([]);
  const [isTopBarVisible, setIsTopBarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const baseUrl = 'https://api.homehive.co.zw/api';
  const [bookings, setBookings] = useState([]);
  const [removingId, setRemovingId] = useState(null);
  const [referred_count, setReferredCount] = useState(0)
  const [rewardAmount, setRewardAmount] = useState(0)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    first_name: '',
    last_name: '',
    phone: ''
  });
  const [isUpdating, setIsUpdating] = useState(false);
  const [subscription, setSubscription] = useState({
    status: 'active', // active, expired, inactive
    expiry_date: null,
    plan_name: 'Premium',
    balance: 0
  });
  const [isAddFundsModalOpen, setIsAddFundsModalOpen] = useState(false);
  const [fundsAmount, setFundsAmount] = useState('');
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentCheckInterval, setPaymentCheckInterval] = useState(null);

  const [subscriptionPlans] = useState([
    {
      id: 1,
      name: 'Monthly Access',
      price: 0.01,
      duration: '/month',
      features: [
        'Contact unlimited landlords',
        'Chat with property owners',
        'Schedule viewings',
      ]
    }
  ]);

  const [paymentFormData, setPaymentFormData] = useState({
    amount: subscriptionPlans[0].price,
    payment_method: '',
    phone: ''
  });

  // Color scheme consistent with the application
  const colors = {
    primary: '#1a237e', // Main primary color
    primaryHover: '#151b60', // Darker shade for hover states
    primaryLight: '#eef2ff', // Light primary for backgrounds
    secondary: '#2c3e50', // Secondary text color
    accent: '#487FFF', // Accent color (primary-600)
    danger: '#ff4757', // For delete/remove buttons
    success: '#45B369', // For success states
    neutral: {
      50: '#F5F6FA',
      100: '#F3F4F6',
      200: '#EBECEF',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      900: '#111827',
    }
  };

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => {
      if (paymentCheckInterval) {
        clearInterval(paymentCheckInterval);
      }
    };
  }, [paymentCheckInterval]);

  useEffect(() => {
    // Fetch profile details
    const fetchProfile = async () => {
      try {
        setIsLoading(true);
        const resp = await axios.get(`${baseUrl}/profile/`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        console.log(resp.data)
        setProfile(resp.data.user);
        setReferredCount(resp?.data?.reffered_count)
        setRewardAmount(resp?.data?.reward)
        const code = resp?.data?.user?.referral_code || resp?.data?.referral || 'YOUR_CODE';
        setReferralLink(`https://homehive.co.zw/signup?ref=${code}`);
        setBookings(resp?.data?.bookings || []);
        setFavoriteProperties(resp?.data?.favorites || []);

        // Set subscription data if available
        if (resp?.data?.user) {
          setSubscription({
            is_subscribed: resp.data?.user?.is_subscribed,
            expiry_date: resp.data?.user?.subscription_end_date,
            plan_name: 'Premium',
          });
        }

        console.log(bookings)
        setError(null);
      } catch (e) {
        console.error('Failed to load profile', e);
        setError('Failed to load profile');
      } finally {
        setIsLoading(false);
      }
    };
    fetchProfile();

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsTopBarVisible(currentScrollY < lastScrollY || currentScrollY < 50);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleCopyReferralLink = () => {
    navigator.clipboard.writeText(referralLink);
    const notification = document.createElement('div');
    notification.className = 'copy-notification';
    notification.textContent = 'Referral link copied!';
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  };

  const handleChangePassword = () => {
    // Implement password change logic
    alert('Password change functionality not implemented yet.');
  };

  const handleEditProfile = () => {
    // Populate form with current profile data
    setEditFormData({
      first_name: profile?.name || '',
      last_name: profile?.surname || '',
      phone: profile?.phone || profile?.phone_number || ''
    });
    setIsEditModalOpen(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateProfile = async () => {
    if (!editFormData.first_name.trim() || !editFormData.last_name.trim()) {
      alert('First name and last name are required');
      return;
    }

    setIsUpdating(true);
    try {
      const response = await axios.put(`${baseUrl}/user/`, {
        name: editFormData.first_name.trim(),
        surname: editFormData.last_name.trim(),
        phone: editFormData.phone.trim()
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      console.log(response)

      // Update local profile state
      setProfile(prev => ({
        ...prev,
        name: editFormData.first_name.trim(),
        surname: editFormData.last_name.trim(),
        phone: editFormData.phone.trim(),
        phone_number: editFormData.phone.trim()
      }));

      setIsEditModalOpen(false);

      // Show success message
      const notification = document.createElement('div');
      notification.className = 'success-notification';
      notification.textContent = 'Profile updated successfully!';
      document.body.appendChild(notification);
      setTimeout(() => notification.remove(), 3000);

    } catch (error) {
      console.error('Failed to update profile:', error);
      alert('Failed to update profile. Please try again.');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditFormData({
      first_name: '',
      last_name: '',
      phone: ''
    });
  };

  const handleAddFunds = () => {
    // Use subscription modal instead of add funds modal
    setShowSubscriptionModal(true);
  };

  const handleFundsAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and one decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setFundsAmount(value);
    }
  };

  const handleSubmitFunds = async () => {
    if (!fundsAmount || parseFloat(fundsAmount) <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    try {
      // Here you would integrate with your payment gateway
      // For now, we'll simulate the process
      const response = await axios.post(`${baseUrl}/subscription/add-funds/`, {
        amount: parseFloat(fundsAmount)
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      // Update local subscription state
      setSubscription(prev => ({
        ...prev,
        balance: prev.balance + parseFloat(fundsAmount)
      }));

      setIsAddFundsModalOpen(false);
      setFundsAmount('');

      // Show success message
      const notification = document.createElement('div');
      notification.className = 'success-notification';
      notification.textContent = `$${fundsAmount} added to your account!`;
      document.body.appendChild(notification);
      setTimeout(() => notification.remove(), 3000);

    } catch (error) {
      console.error('Failed to add funds:', error);
      alert('Failed to add funds. Please try again.');
    }
  };

  const handleCloseFundsModal = () => {
    setIsAddFundsModalOpen(false);
    setFundsAmount('');
  };

  const handleSubscriptionClick = () => {
    if (!token) {
      Swal.fire({
        title: 'Authentication Required',
        text: 'Please log in to access premium features',
        icon: 'warning',
        confirmButtonColor: '#1a237e',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Login'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login');
        }
      });
      return;
    }
    setShowSubscriptionModal(true);
  };

  const handleSubscribe = async (planId) => {
    if (!token) {
      Swal.fire({
        title: 'Authentication Required',
        text: 'Please log in to subscribe',
        icon: 'warning',
        confirmButtonColor: '#1a237e',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Login'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login');
        }
      });
      return;
    }

    if (!paymentMethod) {
      Swal.fire({
        title: 'Select Payment Method',
        text: 'Please select a payment method to continue',
        icon: 'warning',
        confirmButtonColor: '#1a237e'
      });
      return;
    }

    try {
      setIsProcessingPayment(true);

      // Validate amount
      if (!paymentFormData.amount || paymentFormData.amount <= 0) {
        throw new Error('Invalid payment amount');
      }

      // For EcoCash payments, get phone number
      let phoneNumber = '';
      if (paymentMethod === 'ecocash') {
        const result = await Swal.fire({
          title: 'Enter EcoCash Phone Number',
          input: 'tel',
          inputLabel: 'Phone Number',
          inputPlaceholder: 'Enter your EcoCash number',
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return 'Please enter your phone number';
            }
            // Basic Zimbabwe phone number validation
            const phoneRegex = /^(?:\+263|0)7[7-8][0-9]{7}$/;
            if (!phoneRegex.test(value)) {
              return 'Please enter a valid Zimbabwe phone number';
            }
          },
          confirmButtonColor: '#1a237e',
          cancelButtonColor: '#64748b'
        });

        if (result.dismiss) {
          setIsProcessingPayment(false);
          return;
        }

        phoneNumber = result.value;
        if (!phoneNumber) {
          setIsProcessingPayment(false);
          return;
        }
      }

      // Prepare payment data
      const paymentData = {
        amount: parseFloat(paymentFormData.amount.toString()),
        payment_method: paymentMethod
      };

      // Add phone number for EcoCash payments
      if (paymentMethod === 'ecocash') {
        paymentData.phone = phoneNumber;
      }

      // Initiate payment
      const response = await axios.post(
        `${baseUrl}/payment/`,
        paymentData,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.data.status === 'success') {
        const { reference, pollUrl, instructions } = response.data;

        if (paymentMethod === 'ecocash') {
          // Show loading dialog instead of confirmation button
          Swal.fire({
            title: 'Processing EcoCash Payment',
            text: 'Please check your phone for the payment prompt and enter your PIN to confirm.',
            icon: 'info',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cancel Payment',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else if (paymentMethod === 'visa') {
          // Redirect to payment gateway
          window.location.href = pollUrl;
          return;
        }

        // Start polling for payment status
        const pollInterval = setInterval(async () => {
          try {
            const statusResponse = await axios.get(
              `${baseUrl}/payment/`,
              {
                params: {
                  reference: reference,
                  pollUrl: pollUrl
                },
                headers: { 'Authorization': `Bearer ${token}` }
              }
            );

            const { status, message } = statusResponse.data;

            if (status === 'paid') {
              clearInterval(pollInterval);
              setPaymentCheckInterval(null);
              setIsProcessingPayment(false);
              setShowSubscriptionModal(false);

              Swal.fire({
                title: 'Subscription Successful!',
                text: message || 'You can now contact landlords and access all features',
                icon: 'success',
                confirmButtonColor: '#1a237e'
              }).then(() => {
                // Refresh page to update subscription status
                window.location.reload();
              });
            } else if (status === 'cancelled' || status === 'failed') {
              clearInterval(pollInterval);
              setPaymentCheckInterval(null);
              setIsProcessingPayment(false);

              Swal.fire({
                title: 'Payment Failed',
                text: message || 'Payment was cancelled or failed. Please try again.',
                icon: 'error',
                confirmButtonColor: '#1a237e'
              });
            }
            // Continue polling for 'pending' status
          } catch (error) {
            console.error('Error checking payment status:', error);
            clearInterval(pollInterval);
            setPaymentCheckInterval(null);
            setIsProcessingPayment(false);

            Swal.fire({
              title: 'Error',
              text: error.response?.data?.detail || 'Failed to check payment status',
              icon: 'error',
              confirmButtonColor: '#1a237e'
            });
          }
        }, 5000);

        setPaymentCheckInterval(pollInterval);
      } else {
        throw new Error(response.data.detail || 'Failed to initiate payment');
      }
    } catch (error) {
      console.error('Payment error:', error);
      setIsProcessingPayment(false);
      
      Swal.fire({
        title: 'Payment Error',
        text: error.response?.data?.detail || error.message || 'Payment initiation failed',
        icon: 'error',
        confirmButtonColor: '#1a237e'
      });
    }
  };

  // Update payment method selection in subscription modal
  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
    setPaymentFormData(prev => ({
      ...prev,
      payment_method: method,
      phone: method === 'ecocash' ? prev.phone : ''
    }));
  };

  const getSubscriptionStatusColor = (status) => {
    switch (status) {
      case true:
        return '#10b981'; // green
      case false:
        return '#ef4444'; // red
      case 'inactive':
        return '#6b7280'; // gray
      default:
        return '#6b7280';
    }
  };

  const getSubscriptionStatusText = (status) => {
    switch (status) {
      case true:
        return 'Active';
      case false:
        return 'Expired';
      case 'inactive':
        return 'Inactive';
      default:
        return 'Unknown';
    }
  };

  const handleRemoveFavorite = async (favItem) => {
    const favId = favItem?.id;
    const propertyId = (favItem?.property || favItem?.property_details || favItem)?.id;
    if (!token) {
      return;
    }
    try {
      setRemovingId(favId || propertyId);
      // Try resource delete first if id is present
      if (favId) {
        await axios.delete(`${baseUrl}/favourite-properties/`, {
          headers: { Authorization: `Bearer ${token}` },
          data: { property: propertyId }
        });
      } else if (propertyId) {
        // Fallback: send DELETE with body containing property id
        await axios.delete(`${baseUrl}/favourite-properties/`, {
          headers: { Authorization: `Bearer ${token}` },
          data: { property: propertyId }
        });
      }
      setFavoriteProperties((prev) => prev.filter((f) => (f.id || (f.property || f.property_details || f)?.id) !== (favId || propertyId)));
    } catch (e) {
      console.error('Failed to remove favourite', e);
    } finally {
      setRemovingId(null);
    }
  };

  return (
    <>
      <TopBar isVisible={isTopBarVisible} />
      <div className="profile-page">

        <div className="profile-content">
          <div className="profile-card">
            <div className="card-header">
              <h2 style={{ fontSize: '16px' }}><i className="fas fa-user"></i> Personal Information</h2>
              <button
                style={{ marginLeft: '20%', marginRight: 'auto', width: '80%' }}
                className="edit-btn"
                onClick={handleEditProfile}
              >
                <i className="fas fa-edit"></i> Edit
              </button>
            </div>
            <div className="card-content">
              {isLoading ? (
                <div>Loading profile...</div>
              ) : error ? (
                <div style={{ color: '#e11d48' }}>{error}</div>
              ) : (
                <>
                  <div className="info-group">
                    <label>Full Name</label>
                    <p>{profile?.name || ''} {profile?.surname}</p>
                  </div>
                  <div className="info-group">
                    <label>Email</label>
                    <p>{profile?.email || '-'}</p>
                  </div>
                  <div className="info-group">
                    <label>Phone</label>
                    <p>{profile?.phone || profile?.phone_number || '-'}</p>
                  </div>

                </>
              )}
            </div>
          </div>

          <div className="profile-card">
            <div className="card-header">
              <h2><i className="fas fa-crown"></i> Subscription Status</h2>
            </div>
            <div className="card-content">
              <div className="subscription-info">
                <div className="subscription-status">
                  <div className="status-badge12" style={{
                    backgroundColor: getSubscriptionStatusColor(subscription.is_subscribed),
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'inline-block',
                    marginBottom: '16px'
                  }}>
                    <i className="fas fa-circle" style={{ marginRight: '6px', fontSize: '8px' }}></i>
                    {getSubscriptionStatusText(subscription.is_subscribed)}
                  </div>
                </div>

                <div className="subscription-details">
                  <div className="info-group">
                    <label>Plan</label>
                    <p style={{ fontWeight: '600', color: '#1a237e' }}>{subscription.plan_name}</p>
                  </div>

                  {subscription.expiry_date && (
                    <div className="info-group">
                      <label>Expiry Date</label>
                      <p style={{
                        color: subscription.is_subscribed ? '#10b981' : '#ef4444',
                        fontWeight: !subscription.is_subscribed ? '600' : '400'
                      }}>
                        {new Date(subscription.expiry_date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                  )}
                </div>

                <div className="subscription-actions" style={{ marginTop: '20px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {!subscription.is_subscribed ? (
                    <button
                      className="renew-btn"
                      onClick={handleAddFunds}
                      style={{
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                    >
                      <i className="fas fa-sync-alt"></i>
                      Renew Subscription
                    </button>
                  ) : (
                    <button
                      className="topup-btn"
                      onClick={handleAddFunds}
                      style={{
                        backgroundColor: '#1a237e',
                        color: 'white',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#151b60'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#1a237e'}
                    >
                      <i className="fas fa-plus"></i>
                      Top Up Account
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="profile-card">
            <div className="card-header">
              <h2><i className="fas fa-share-alt"></i> Referral Program</h2>
            </div>
            <div className="card-content">
              <p className="referral-info">Share your referral link and earn rewards when friends join!</p>
              <div className="referral-box">
                <input
                  type="text"
                  value={referralLink}
                  readOnly
                  className="referral-input"
                />
                <button onClick={handleCopyReferralLink} className="copy-btn">
                  <i className="fas fa-copy"></i> Copy
                </button>
              </div>
              <div className="referral-stats">
                <div className="stat-item">
                  <span className="stat-number">{referred_count || 0}</span>
                  <span className="stat-label">Referred users</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">${rewardAmount}</span>
                  <span className="stat-label">Worth of airtime</span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ width: '90vw', background: '#fff', }} className="profile-card">
            <div className="card-header">
              <h2><i className="fas fa-heart"></i> Favorite Properties</h2>
            </div>
            <div className="card-content">
              {favoriteProperties.length > 0 ? (
                <div className="favorites-grid" style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '20px',
                  maxWidth: '100%'
                }}>
                  {favoriteProperties.map((fav) => {
                    const p = fav?.property || fav;
                    const imgSrc = p?.images && p.images[0]?.image ? `${baseUrl}${p.images[0].image}` : 'images/homehive.png';
                    const title = p?.title || p?.property_type_display || 'Property';
                    const location = p?.location || '-';
                    const amount = p?.monthly_rental ?? p?.price_per_night ?? p?.price;
                    const period = p?.property_type === 'lodge' ? '/night' : '/month';
                    const cardKey = fav?.id || p?.id || title;
                    return (
                      <div
                        key={cardKey}
                        onClick={() => navigate(`/properties/${p?.id}`)}
                        className="favorite-property"
                        style={{
                          border: '1px solid #e5e7eb',
                          borderRadius: '10px',
                          overflow: 'hidden',
                          background: '#fff',
                          boxShadow: '0 4px 14px rgba(0,0,0,0.06)',
                          cursor: 'pointer',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          width: '100%',
                          maxWidth: '100%'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.06)';
                        }}
                      >
                        <div className="property-image" style={{ position: 'relative' }}>
                          <img src={imgSrc} alt={title} />
                          <button
                            className="remove-favorite"
                            title="Remove"
                            onClick={(e) => { e.stopPropagation(); handleRemoveFavorite(fav); }}
                            style={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                              background: '#fff',
                              border: '1px solid #e5e7eb',
                              borderRadius: '9999px',
                              width: 34,
                              height: 34,
                              display: 'grid',
                              placeItems: 'center',
                              color: '#1f2937'
                            }}
                            disabled={removingId === (fav?.id || p?.id)}
                          >
                            {removingId === (fav?.id || p?.id) ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-trash"></i>}
                          </button>
                        </div>
                        <div className="property-info" style={{ padding: '10px 12px' }}>
                          <h6 style={{ fontSize: '16px', fontWeight: 700, color: '#111827', marginBottom: 6 }}>{title}</h6>
                          <p className="location" style={{ color: '#6b7280', marginBottom: 6 }}>
                            <i className="fas fa-map-marker-alt" style={{ marginRight: 6 }} /> {location}
                          </p>
                          <p className="price" style={{ color: 'navy', fontWeight: 700 }}>
                            {amount ? `$${amount}` : '-'}{amount ? ` ${period}` : ''}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="empty-favorites">
                  <i className="fas fa-heart-broken"></i>
                  <p>You haven't saved any properties yet</p>
                  <Link to="/properties" className="browse-properties-btn">
                    Browse Properties
                  </Link>
                </div>
              )}
            </div>
          </div>


        </div>
        {/* <div className="bookings-section" style={{ width: '90vw', background: '#fff' }}>
          <div className="container" style={{ padding: '16px 20px' }}>
            <div className="card-header" style={{ borderBottom: '1px solid #e5e7eb', marginBottom: '12px' }}>
              <h2 style={{ margin: 0 }}><i className="fas fa-calendar-check"></i> Bookings</h2>
            </div>
            {bookings && bookings.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#eef2ff', color: '#1a237e' }}>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Property</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Location</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Visit Date</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Time In</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Time Out</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Status</th>
                      <th style={{ textAlign: 'right', padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookings.map((b) => (
                      <tr key={b.id}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>{b?.property_details?.type_display || b?.property_details?.property_type_display || 'Property'}</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>{b?.property_details?.location || '-'}</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>
                          {b.visit_date || b?.created_at ? new Date(b.visit_date || b.created_at).toLocaleDateString() : '-'}
                        </td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>
                          {b?.visit_time_check_in ? new Date(`1970-01-01T${b.visit_time_check_in}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                        </td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>
                          {b?.visit_time_check_out ? new Date(`1970-01-01T${b.visit_time_check_out}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                        </td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>
                          <span style={{
                            padding: '2px 8px',
                            borderRadius: '12px',
                            background: b.status === 'confirmed' ? '#dcfce7' : b.status === 'pending' ? '#fef9c3' : '#fee2e2',
                            color: b.status === 'confirmed' ? '#166534' : b.status === 'pending' ? '#854d0e' : '#991b1b'
                          }}>
                            {b.status || 'pending'}
                          </span>
                        </td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e5e7eb', textAlign: 'right', color: '#1a237e', fontWeight: 600 }}>
                          ${typeof b?.property_details?.monthly_rental === 'number' ? `$ ${b?.property_details?.monthly_rental}` : (b?.property_details?.monthly_rental || '-')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-favorites">
                <i className="fas fa-calendar-times"></i>
                <p>No bookings yet</p>
              </div>
            )}
          </div>
        </div> */}
      </div>

      {/* Edit Profile Modal */}
      {isEditModalOpen && (
        <div style={{ overflowY: 'hidden' }} className="modal-overlay" onClick={handleCloseEditModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3><i className="fas fa-edit"></i> Edit Profile</h3>
              <button className="modal-close" onClick={handleCloseEditModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="first_name">First Name *</label>
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  value={editFormData.first_name}
                  onChange={handleEditFormChange}
                  className="form-input"
                  placeholder="Enter first name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="last_name">Last Name *</label>
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={editFormData.last_name}
                  onChange={handleEditFormChange}
                  className="form-input"
                  placeholder="Enter last name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={editFormData.phone}
                  onChange={handleEditFormChange}
                  className="form-input"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-cancel"
                onClick={handleCloseEditModal}
                disabled={isUpdating}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-save"
                onClick={handleUpdateProfile}
                disabled={isUpdating}
              >
                {isUpdating ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Updating...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save"></i>
                    Save Changes
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Funds Modal */}
      {isAddFundsModalOpen && (
        <div style={{ overflowY: 'hidden' }} className="modal-overlay" onClick={handleCloseFundsModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                <i className={`fas fa-${!subscription.is_subscribed ? 'sync-alt' : 'plus'}`}></i>
                {!subscription.is_subscribed ? 'Renew Subscription' : 'Top Up Account'}
              </h3>
              <button className="modal-close" onClick={handleCloseFundsModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">

              <div className="form-group">
                <label htmlFor="funds_amount">
                  {!subscription.is_subscribed ? 'Renewal Amount (USD) *' : 'Amount to Add (USD) *'}
                </label>
                <div style={{ position: 'relative' }}>
                  <span style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#6b7280',
                    fontSize: '16px',
                    fontWeight: '600'
                  }}>$</span>
                  <input
                    type="text"
                    id="funds_amount"
                    name="funds_amount"
                    value={fundsAmount}
                    onChange={handleFundsAmountChange}
                    className="form-input"
                    placeholder="0.00"
                    style={{ paddingLeft: '32px' }}
                    required
                  />
                </div>
                <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
                  Minimum amount: $2.00
                </p>
              </div>

              <div className="payment-methods" style={{ marginTop: '20px' }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#374151' }}>Payment Methods</h4>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>

                  <div style={{
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#6b7280',
                    backgroundColor: '#f9fafb'
                  }}>
                    <i className="fas fa-mobile-alt" style={{ marginRight: '4px' }}></i>
                    Ecocash
                  </div>
                  <div style={{
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#6b7280',
                    backgroundColor: '#f9fafb'
                  }}>
                    <i className="fas fa-mobile-alt" style={{ marginRight: '4px' }}></i>
                    One Money
                  </div>

                  <div style={{
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#6b7280',
                    backgroundColor: '#f9fafb'
                  }}>
                    <i className="fas fa-mobile-alt" style={{ marginRight: '4px' }}></i>
                    Omari
                  </div>

                  <div style={{
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#6b7280',
                    backgroundColor: '#f9fafb'
                  }}>
                    <i className="fas fa-mobile-alt" style={{ marginRight: '4px' }}></i>
                    Innbucks
                  </div>

                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-cancel"
                onClick={handleCloseFundsModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-save"
                onClick={handleSubmitFunds}
                disabled={!fundsAmount || parseFloat(fundsAmount) <= 0}
              >
                <i className="fas fa-credit-card"></i>
                {!subscription.is_subscribed ? 'Renew Subscription' : 'Proceed to Payment'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Subscription Modal */}
      <Modal
        isOpen={showSubscriptionModal}
        onRequestClose={() => setShowSubscriptionModal(false)}
        className="subscription-modal"
        overlayClassName="modal-overlay"
        ariaHideApp={false}
      >
        <div className="subscription-header">
          <h2 style={{fontSize: '20px'}}>
            {!subscription.is_subscribed ? 'Subscribe to Contact Landlords' : 'Top Up Your Account'}
          </h2>
          <button onClick={() => setShowSubscriptionModal(false)} className="close-button">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="subscription-content">
          <div className="subscription-plan">
            {subscriptionPlans.map((plan) => (
              <div key={plan.id} className="plan-card">
                <div className="plan-header">
                  <h3 style={{fontSize: '18px'}}>
                    {!subscription.is_subscribed ? plan.name : 'Account Top-Up'}
                  </h3>
                  <div style={{color: '#fff', backgroundColor: 'navy', padding: '10px', borderRadius: '5px'}} className="plan-price">
                    <span className="currency">$</span>
                    <span style={{fontSize: '20px'}} className="amount">{plan.price}</span>
                    <span className="duration">{!subscription.is_subscribed ? plan.duration : ''}</span>
                  </div>
                </div>
                <div className="plan-features">
                  {!subscription.is_subscribed ? (
                    plan.features.map((feature, index) => (
                      <div key={index} className="feature-item">
                        <i className="fas fa-check"></i>
                        <span>{feature}</span>
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="feature-item">
                        <i className="fas fa-check"></i>
                        <span>Add funds to your account</span>
                      </div>
                      <div className="feature-item">
                        <i className="fas fa-check"></i>
                        <span>Extend your subscription</span>
                      </div>
                      <div className="feature-item">
                        <i className="fas fa-check"></i>
                        <span>Continue accessing premium features</span>
                      </div>
                    </>
                  )}
                </div>
                
                <div className="payment-methods">
                  <h4 style={{fontSize: '18px'}}>Select Payment Method</h4>
                  <div className="payment-options">
                    <button
                      className={`payment-option ${paymentMethod === 'ecocash' ? 'selected' : ''}`}
                      onClick={() => handlePaymentMethodChange('ecocash')}
                      disabled={isProcessingPayment}
                    >
                      <img src="data:image/png;base64,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" alt="EcoCash" />
                      <span>EcoCash</span>
                    </button>
                    <button
                      className={`payment-option ${paymentMethod === 'visa' ? 'selected' : ''}`}
                      onClick={() => handlePaymentMethodChange('visa')}
                      disabled={isProcessingPayment}
                    >
                      <img src="data:image/png;base64,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" alt="Visa" />
                      <span>Visa Card</span>
                    </button>
                  </div>
                </div>

                <button 
                  className="subscribe-btn"
                  onClick={() => handleSubscribe(plan.id)}
                  disabled={isProcessingPayment || !paymentMethod}
                >
                  {isProcessingPayment ? (
                    <span className="processing">
                      <i className="fas fa-spinner fa-spin"></i>
                      Processing...
                    </span>
                  ) : (
                    !subscription.is_subscribed ? 'Subscribe Now' : 'Top Up Account'
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

// Add CSS styles for the edit modal and notifications
const style = document.createElement('style');
style.innerHTML = `
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  color: #1a237e;
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f3f4f6;
  color: #374151;
}

.modal-body {
  padding: 24px;
}

.modal-body .form-group {
  margin-bottom: 20px;
}

.modal-body .form-group:last-child {
  margin-bottom: 0;
}

.modal-body label {
  display: block;
  margin-bottom: 6px;
  color: #374151;
  font-weight: 500;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #1a237e;
  box-shadow: 0 0 0 3px rgba(26, 35, 126, 0.1);
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
  justify-content: flex-end;
}

.btn-cancel, .btn-save {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-cancel {
  background: #f3f4f6;
  color: #374151;
}

.btn-cancel:hover:not(:disabled) {
  background: #e5e7eb;
}

.btn-save {
  background: #1a237e;
  color: white;
}

.btn-save:hover:not(:disabled) {
  background: #151b60;
}

.btn-cancel:disabled, .btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #10b981;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  font-weight: 500;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Favorites Grid Responsive Design */
.favorites-grid {
  display: grid;
  gap: 20px;
}

/* Large screens - 2 columns */
@media screen and (min-width: 1024px) {
  .favorites-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Medium screens - 1 column with larger cards */
@media screen and (max-width: 1023px) and (min-width: 768px) {
  .favorites-grid {
    grid-template-columns: 1fr;
  }
}

/* Small screens - 1 column */
@media screen and (max-width: 767px) {
  .favorites-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

/* Responsive design */
@media screen and (max-width: 640px) {
  .modal-content {
    margin: 10px;
    max-width: none;
  }
  
  .modal-header, .modal-body, .modal-footer {
    padding: 16px;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .btn-cancel, .btn-save {
    width: 100%;
    justify-content: center;
  }
}
`;
document.head.appendChild(style);

export default TenantProfile;
